// @flow
import * as React from "react";
import styled, { css } from "styled-components";

import { rgba } from "polished";
import { gaReducer } from "../GA";

const Container = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  vertical-align: middle;
  height: 53px;
  min-width: 42px;

  @media (max-width: 959px) {
    height: 38px;
  }
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  width: 36px;
  height: 36px;
  color: ${rgba("#919191", 0.59)};
  background-color: ${({ theme }) => theme.background};
  transition: all 0.3s ease;
  cursor: pointer;

  :first-child {
    border-radius: 8px 0 0 8px;
  }

  :last-child {
    border-radius: 0 8px 8px 0;
  }

  :not(:first-of-type) {
    margin-left: 1px;
  }

  :hover {
    color: ${({ theme }) => theme.foreground};
  }

  ${({ active, theme }) =>
    active &&
    css`
      color: ${theme.background};
      background-color: ${theme.themeToggleActive};
      pointer-events: none;
    `};
`;

type Props = {
  value: mixed,
  onClick: (key: mixed) => void,
  buttons: Array<{
    icon: React.Node,
    key: string,
    active?: boolean
  }>
};

const ToolBelt = ({ value, onClick, buttons = [] }: Props) => (
  <Container>
    {buttons.map(({ icon, key, active }) => (
      <Button
        key={key}
        active={active ? active : key === value}
        onClick={() => {
          gaReducer("CLICKBTN_CHANGE_THEME", {
            theme: key === "dark" || key === "default" ? "night" : "day"
          });

          return onClick(key);
        }}
      >
        {icon}
      </Button>
    ))}
  </Container>
);

export default ToolBelt;



// WEBPACK FOOTER //
// ./src/components/Toolbar/ToolBelt.js